const STORAGE_KEY_PREFIX = 'tour_session_state_';
const STORAGE_VERSION = 1;

export const TOUR_HIDE_PROMPT_SKIP_THRESHOLD = 2;

const DEFAULT_STATE = {
  version: STORAGE_VERSION,
  skipCount: 0,
  hideAllToursPrompted: false,
};

const getStorageKey = (userId, teamId) => {
  if (!userId || !teamId) return null;
  return `${STORAGE_KEY_PREFIX}${userId}_${teamId}`;
};

const normalizeState = (value) => {
  if (!value || typeof value !== 'object') {
    return DEFAULT_STATE;
  }

  const skipCount = Number.isFinite(value.skipCount) ? value.skipCount : 0;

  return {
    version: STORAGE_VERSION,
    skipCount: Math.max(0, skipCount),
    hideAllToursPrompted: Boolean(value.hideAllToursPrompted),
  };
};

export const getTourSessionState = (userId, teamId) => {
  const storageKey = getStorageKey(userId, teamId);
  if (!storageKey || typeof window === 'undefined') {
    return DEFAULT_STATE;
  }

  try {
    const raw = window.sessionStorage.getItem(storageKey);
    if (!raw) return DEFAULT_STATE;

    const parsed = JSON.parse(raw);
    if (parsed?.version !== STORAGE_VERSION) {
      return DEFAULT_STATE;
    }

    return normalizeState(parsed);
  } catch {
    return DEFAULT_STATE;
  }
};

export const setTourSessionState = (userId, teamId, state) => {
  const storageKey = getStorageKey(userId, teamId);
  if (!storageKey || typeof window === 'undefined') return;

  try {
    window.sessionStorage.setItem(
      storageKey,
      JSON.stringify(normalizeState(state))
    );
  } catch {
    // Ignore storage errors.
  }
};

export const clearTourSessionState = (userId, teamId) => {
  const storageKey = getStorageKey(userId, teamId);
  if (!storageKey || typeof window === 'undefined') return;

  try {
    window.sessionStorage.removeItem(storageKey);
  } catch {
    // Ignore storage errors.
  }
};

export const getDefaultTourSessionState = () => DEFAULT_STATE;
